import React from 'react'
import { TextField, InputAdornment } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'

const Telno = ({ handleOnChange, register, value, withIcon }) => {
	return (
		<TextField
			variant='outlined'
			fullWidth
			id='telno'
			label='Telephone number'
			name='telno'
			value={value}
			onChange={handleOnChange}
			InputProps={{
				endAdornment: withIcon ? (
					<InputAdornment position='start'>
						<PhoneIcon />
					</InputAdornment>
				) : null
			}}
		/>
	)
}

export default Telno
